import React from "react";
import PropTypes from "prop-types";
import AdfitWebComponent from "react-adfit-web-component";

const Adfit = (props) => {
  return <AdfitWebComponent {...props} />;
};

Adfit.propTypes = {
  adUnit: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};
export default Adfit;
